import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { getErrorEndOTP, getErrorMessage } from "app/shared/services/axios";
import { ACCOUNTBYPHONE, RESPONSEBASE } from "app/shared/services/services-model.type";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTransferCharityAccountDetailService,
  fetchTransferCharityAuthService,
  fetchTransferCharityConfirmService,
  fetchTransferCharityCreateService,
  fetchTransferCharityDetailByPhoneService,
} from "../services/transfer-charity.service";
import {
  fetchTransferCharityAccountDetailFailure,
  fetchTransferCharityAccountDetailSuccess,
  fetchTransferCharityAuthorizationFailure,
  fetchTransferCharityAuthorizationSuccess,
  fetchTransferCharityConfirmFailure,
  fetchTransferCharityConfirmSuccess,
  fetchTransferCharityCreateFailure,
  fetchTransferCharityCreateSuccess,
  fetchTransferCharityDetailByPhoneFailure,
  fetchTransferCharityDetailByPhoneSuccess,
  fetchTransferCharityMakeFeeFailure,
  fetchTransferCharityMakeFeeSuccess,
} from "./actions";
import {
  FETCH_TRANSFER_CHARITY_ACCOUNT_DETAIL_REQUEST,
  FETCH_TRANSFER_CHARITY_AUTHORIZATION_KEY_REQUEST,
  FETCH_TRANSFER_CHARITY_CONFIRM_REQUEST,
  FETCH_TRANSFER_CHARITY_CREATE_REQUEST,
  FETCH_TRANSFER_CHARITY_DETAIL_BY_PHONE_REQUEST,
  FETCH_TRANSFER_CHARITY_MAKE_FEE_REQUEST,
} from "./actions.type";
import {
  FetchTransferCharityAccountDetailRequest,
  FetchTransferCharityAuthorizationRequest,
  FetchTransferCharityConfirmRequest,
  FetchTransferCharityCreateRequest,
  FetchTransferCharityDetailByPhoneRequest,
  FetchTransferCharityMakeFeeRequest,
} from "./types";

function* fetchTransferCharityAccountDetailSaga(action: FetchTransferCharityAccountDetailRequest) {
  try {
    if (action.showLoading) yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferCharityAccountDetailService(action));
    console.log("fetchTransferCharityAccountDetail response: ", response);
    if (action.showLoading) yield put(hideModal());
    if (response.status === 200) {
      const accountProfile = response.data.RESPONSEDATA?.ACCOUNTPROFILE;
      yield put(fetchTransferCharityAccountDetailSuccess(accountProfile));
    }
  } catch (e: any | AxiosError) {
    if (action.showLoading) yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferCharityAccountDetailFailure(msg));
  }
}

function* fetchTransferCharityDetailByPhoneSaga(action: FetchTransferCharityDetailByPhoneRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<ACCOUNTBYPHONE> = yield call(() => fetchTransferCharityDetailByPhoneService(action.payload));
    console.log("fetchTransferCharityAccountDetail response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTransferCharityDetailByPhoneSuccess(response.data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferCharityDetailByPhoneFailure(msg));
  }
}

function* fetchTransferCharityMakeFeeSaga(action: FetchTransferCharityMakeFeeRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferCharityCreateService(action.payload));
    console.log("fetchTransferCharityMakeFee response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTransferCharityMakeFeeSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferCharityMakeFeeFailure(msg));
  }
}

function* fetchTransferCharityCreateSaga(action: FetchTransferCharityCreateRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferCharityCreateService(action.payload));
    console.log("fetchTransferCharityCreate response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTransferCharityCreateSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferCharityCreateFailure(msg));
  }
}

function* fetchTransferCharityConfirmSaga(action: FetchTransferCharityConfirmRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferCharityConfirmService(action));
    console.log("fetchTransferCharityConfirm response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTransferCharityConfirmSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferCharityConfirmFailure(msg));
  }
}

function* fetchTransferCharityAuthSaga(action: FetchTransferCharityAuthorizationRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferCharityAuthService(action));
    console.log("fetchTransferCharityAuth response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTransferCharityAuthorizationSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferCharityAuthorizationFailure(getErrorEndOTP(e), msg));
    getErrorMessage(e, true);
  }
}

function* transferCharitySaga() {
  yield all([
    takeLatest(FETCH_TRANSFER_CHARITY_ACCOUNT_DETAIL_REQUEST, fetchTransferCharityAccountDetailSaga),
    takeLatest(FETCH_TRANSFER_CHARITY_DETAIL_BY_PHONE_REQUEST, fetchTransferCharityDetailByPhoneSaga),
    takeLatest(FETCH_TRANSFER_CHARITY_MAKE_FEE_REQUEST, fetchTransferCharityMakeFeeSaga),
    takeLatest(FETCH_TRANSFER_CHARITY_CREATE_REQUEST, fetchTransferCharityCreateSaga),
    takeLatest(FETCH_TRANSFER_CHARITY_CONFIRM_REQUEST, fetchTransferCharityConfirmSaga),
    takeLatest(FETCH_TRANSFER_CHARITY_AUTHORIZATION_KEY_REQUEST, fetchTransferCharityAuthSaga),
  ]);
}

export default transferCharitySaga;
